<template>
  <div class="order-without-item">
    <div class="owi-shell mx-auto">
      <div class="owi-header text-center mb-4">
        <h4 class="owi-title mb-1">ثبت سفارش سریع</h4>
        <p class="owi-subtitle mb-0 text-muted">
          سفارش بدون محصول — پس از ثبت، لینک پرداخت به‌صورت QR نمایش داده می‌شود
        </p>
      </div>

      <transition name="owi-fade" mode="out-in">
        <div v-if="!qrValue" key="form" class="owi-panel">
          <b-form @submit.prevent="onSubmit">
            <b-row>
              <form-group class="col-md-6" :validations="$v.form.name">
                <div slot-scope="{ errors, invalid }">
                  <b-form-group label="نام">
                    <b-form-input
                      v-model="form.name"
                      :class="{ invalid }"
                      placeholder="نام مشتری"
                      autocomplete="given-name"
                    />
                    <form-errors-manager :errors="errors"/>
                  </b-form-group>
                </div>
              </form-group>

              <form-group class="col-md-6" :validations="$v.form.last_name">
                <div slot-scope="{ errors, invalid }">
                  <b-form-group label="نام خانوادگی">
                    <b-form-input
                      v-model="form.last_name"
                      :class="{ invalid }"
                      placeholder="نام خانوادگی مشتری"
                      autocomplete="family-name"
                    />
                    <form-errors-manager :errors="errors"/>
                  </b-form-group>
                </div>
              </form-group>

              <form-group class="col-md-6" :validations="$v.form.cellphone">
                <div slot-scope="{ errors, invalid }">
                  <b-form-group label="شماره تلفن همراه">
                    <b-form-input
                      v-model="form.cellphone"
                      class="text-left"
                      dir="ltr"
                      :class="{ invalid }"
                      placeholder="09xxxxxxxxx"
                      maxlength="11"
                      inputmode="numeric"
                      autocomplete="tel"
                    />
                    <form-errors-manager :errors="errors"/>
                  </b-form-group>
                </div>
              </form-group>

              <form-group class="col-md-6" :validations="$v.form.amount">
                <div slot-scope="{ errors, invalid }">
                  <b-form-group label="مبلغ (تومان)">
                    <b-form-input
                      v-model="form.amount"
                      class="text-left"
                      dir="ltr"
                      :class="{ invalid }"
                      placeholder="حداقل ۱٬۰۰۰"
                      inputmode="numeric"
                    />
                    <small v-if="form.amount" class="text-muted d-block mt-1">
                      {{ formatNumber(form.amount) }} تومان
                    </small>
                    <form-errors-manager :errors="errors"/>
                  </b-form-group>
                </div>
              </form-group>

              <form-group class="col-12" :validations="$v.form.description">
                <div slot-scope="{ errors, invalid }">
                  <b-form-group label="توضیحات">
                    <textarea
                    class="form-control"
                      v-model="form.description"
                      :class="{ invalid }"
                      rows="4"
                      max-rows="8"
                      placeholder="شرح سفارش یا دلیل پرداخت..."
                    />
                    <form-errors-manager :errors="errors"/>
                  </b-form-group>
                </div>
              </form-group>
            </b-row>

            <div class="text-center mt-2">
              <b-button
                type="submit"
                pill
                variant="primary"
                class="owi-submit px-5"
                :disabled="loading"
              >
                <b-spinner v-if="loading" small class="ml-2"/>
                {{ loading ? 'در حال ثبت...' : 'ثبت و دریافت QR' }}
              </b-button>
            </div>
          </b-form>
        </div>

        <div v-else key="result" class="owi-panel owi-result text-center">
          <div class="owi-success-badge mx-auto mb-3">
            <b-icon icon="check"/>
          </div>
          <h5 class="mb-1">سفارش ثبت شد</h5>
          <p class="text-muted mb-4">
            مشتری می‌تواند با اسکن QR کد زیر، پرداخت را انجام دهد
          </p>

          <div class="owi-qr-wrap mx-auto mb-3">
            <vue-qr :text="qrValue" :size="280" :margin="8"/>
          </div>

          <div v-if="resultMeta.amount" class="owi-meta mb-3">
            <span class="owi-meta-label">مبلغ</span>
            <span class="owi-meta-value">{{ formatNumber(resultMeta.amount) }} تومان</span>
          </div>

          <div class="owi-link-box mx-auto mb-4">
            <code class="owi-link text-left d-block" dir="ltr">{{ qrValue }}</code>
            <div class="owi-link-actions mt-2">
              <b-button size="sm" pill variant="outline-primary" class="mx-1" @click="copyLink">
                <b-icon icon="clipboard" class="ml-1"/>
                کپی لینک
              </b-button>
              <b-button
                size="sm"
                pill
                variant="outline-secondary"
                class="mx-1"
                :href="qrValue"
                target="_blank"
              >
                <b-icon icon="box-arrow-up-right" class="ml-1"/>
                باز کردن
              </b-button>
            </div>
          </div>

          <b-button pill variant="primary" class="px-4" @click="resetForm">
            ثبت سفارش جدید
          </b-button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {required, numeric, minValue, maxLength} from "vuelidate/lib/validators";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import vueQr from "vue-qr/src/packages/vue-qr.vue";

const emptyForm = () => ({
  name: "",
  last_name: "",
  cellphone: "",
  amount: "",
  description: "",
});

export default {
  name: "OrderWithoutItem",
  components: {
    FormGroup,
    FormErrorsManager,
    vueQr,
  },
  data() {
    return {
      form: emptyForm(),
      loading: false,
      qrValue: "",
      resultMeta: {
        amount: null,
      },
    };
  },
  validations: {
    form: {
      name: {required, maxLength: maxLength(255)},
      last_name: {required, maxLength: maxLength(255)},
      cellphone: {required, phone},
      amount: {required, numeric, minValue: minValue(1000)},
      description: {required, maxLength: maxLength(5000)},
    },
  },
  methods: {
    formatNumber,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    extractPaymentUrl(payload) {
      if (!payload) return "";
      if (typeof payload === "string") return payload;

      return (
        payload.payment_link  ||        ""
      );
    },
    async onSubmit() {
      if (!this.invalid() || this.loading) return;

      this.loading = true;
      try {
        const form = {
          name: this.form.name.trim(),
          last_name: this.form.last_name.trim(),
          cellphone: this.form.cellphone.trim(),
          amount: Number(this.form.amount),
          description: this.form.description.trim(),
        };

        const res = await this.$store.dispatch("ShoppingCart/orderWithoutItem", form);
        const data = (res && res.data && res.data.data) || (res && res.data) || {};
        const paymentUrl = this.extractPaymentUrl(data);

        if (!paymentUrl) {
          toast("خطا", "لینک پرداخت از سرور دریافت نشد", "danger");
          return;
        }

        this.qrValue = paymentUrl;
        this.resultMeta.amount = form.amount;
        toast("موفق", "سفارش ثبت شد. QR آماده است.", "success");
      } catch (e) {
        console.log(e);
        toast("خطا", "ثبت سفارش با مشکل مواجه شد", "danger");
      } finally {
        this.loading = false;
      }
    },
    copyLink() {
      if (!this.qrValue) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.qrValue).then(() => {
          toast("کپی شد", "لینک پرداخت کپی شد", "success");
        }).catch(() => {
          this.fallbackCopy(this.qrValue);
        });
      } else {
        this.fallbackCopy(this.qrValue);
      }
    },
    fallbackCopy(value) {
      const input = document.createElement("textarea");
      input.value = value;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      toast("کپی شد", "لینک پرداخت کپی شد", "success");
    },
    resetForm() {
      this.form = emptyForm();
      this.qrValue = "";
      this.resultMeta = {amount: null};
      this.$v.$reset();
    },
  },
};
</script>

<style scoped>
.order-without-item {
  padding: 1.5rem 1rem 3rem;
}

.owi-shell {
  max-width: 720px;
}

.owi-title {
  font-weight: 700;
  letter-spacing: -0.02em;
}

.owi-subtitle {
  font-size: 0.92rem;
}

.owi-panel {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 1.75rem 1.5rem;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
}

.owi-submit {
  min-width: 200px;
}

.owi-success-badge {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(40, 167, 69, 0.12);
  color: #28a745;
  font-size: 1.4rem;
}

.owi-qr-wrap {
  width: fit-content;
  padding: 1rem;
  border-radius: 16px;
  background: #f8fafc;
  border: 1px dashed rgba(0, 0, 0, 0.1);
}

.owi-qr-wrap >>> img,
.owi-qr-wrap /deep/ img {
  display: block;
  max-width: 100%;
  height: auto;
}

.owi-meta {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #f8fafc;
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
}

.owi-meta-label {
  color: #6c757d;
  font-size: 0.85rem;
}

.owi-meta-value {
  font-weight: 600;
}

.owi-link-box {
  max-width: 480px;
}

.owi-link {
  background: #f1f5f9;
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  font-size: 0.78rem;
  word-break: break-all;
  white-space: pre-wrap;
}

.owi-fade-enter-active,
.owi-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.owi-fade-enter,
.owi-fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

.invalid {
  border-color: #dc3545 !important;
}
</style>
